<div class="track-record-page">
  <!-- Breadcrumb Navigation -->
  <div class="breadcrumb">
    <a routerLink="/">Home</a> 
    <span class="separator">></span> 
    <!-- <a routerLink="/ipo">Offer documents</a>  -->
    <!-- <span class="separator">></span>  -->
    <span class="current-page">Track Record</span>
  </div>

  <div class="track-record-container">
    <div class="track-record-card">
      <div class="icon-container">
        <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <div class="content-container">
        <h2 class="title">Important Notice</h2>
        <p class="message">
          Bajaj Capital Securities Limited has not handled any issues in the past.
        </p>
      </div>
    </div>
  </div>
</div>
